import { lazy } from "react";
import Loadable from "../Loadable";

//pages
const NotFound = Loadable(lazy(() => import("pages/404")));

const NotFoundRoutes = {
  path: "*",
  element: <NotFound />,
};

export default NotFoundRoutes;
